import script from "./AudioAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./AudioAttachment.vue?vue&type=style&index=0&id=09e7b63d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09e7b63d"]])

export default __exports__